/* eslint-disable camelcase */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// import PaymentForm from './PaymentForm';
import { connect } from 'react-redux';
import PublicMenu from '../../../components/PublicMenu';
import PaymentMethodForm from '../../../components/AddPaymentMethodModal/PaymentMethodForm';

import './PrepayPayment.scss';

class PrepayPayment extends PureComponent {
	onDone = () => {
		const { history : { push }, match : { params : { estId } } } = this.props;
		if (estId) push(`/InvoiceEstimate/1/${estId}`);
		else push('/jobs/list/needApproval');
	}

	render() {
		const { user } = this.props;

		return (
			<div id="prepay-payment">
				<PublicMenu hideSignIn />
				<div id="payment-content">
					<div id="spacer" className="hidden-xs" />
					<PaymentMethodForm
						user={user}
						successCallback={this.onDone}
						achPrePayEnabled
						isPrePayForm
					/>
					<div id="spacer" className="visible-xs" />
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({ app : { user } }) => ({ user });

PrepayPayment.propTypes = {
	history : PropTypes.object.isRequired,
	match   : PropTypes.object.isRequired,
	user    : PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(PrepayPayment);
